import {z} from 'zod';

import i18n from '@dms/i18n';

import {WheelSchema} from './Wheel';

export const TireSetDetailFormDefinitionSchema = z
  .object({
    assignMechanic: z.string().optional(),
    storedLocation: z.string().nullish(),
    storedUntil: z.string().nullish(),
    categoryId: z.string().nullish(),
    isReplacement: z.boolean(),
    numberOfTires: z.number(),
    wheels: z.array(WheelSchema),
    note: z.string().nullish(),
    contactInformation: z
      .object({
        id: z.string().nullish(),
        contactId: z.string().nullish(),
        identityCard: z.string().nullish(),
        name: z.string().nullish(),
        email: z.string().nullish(),
        phoneNumber: z
          .object({
            countryCode: z.string().nullish(),
            number: z.string().nullish(),
            prefix: z.string().nullish(),
          })
          .nullish(),
      })
      .nullish(),
    destinationBranchId: z.string().nullish(),
    neededAtDate: z.string().nullish(),
    neededAtTime: z.string().nullish(),
    requestNote: z.string().nullish(),
    tireSetRequestEnabled: z.boolean(),
  })
  .superRefine((data, ctx) => {
    if (data.tireSetRequestEnabled && !data.destinationBranchId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('errors.field_is_required'),
        path: ['destinationBranchId'],
      });
    }
    if (data.tireSetRequestEnabled && !data.neededAtDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('errors.field_is_required'),
        path: ['neededAtDate'],
      });
    }
    if (data.tireSetRequestEnabled && !data.neededAtTime) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('errors.field_is_required'),
        path: ['neededAtTime'],
      });
    }
  });

export type TireSetDetailFormDefinition = z.infer<typeof TireSetDetailFormDefinitionSchema>;
